import { create } from "zustand";

import { FetchActionWithOutParams, FetchApiWithoutParams } from "@/types/Api";
import { UserChangeTypeMap } from "@/types/Api/User/change";

type StoreState = {
  changeTypeMap: UserChangeTypeMap;
};

interface StoreActions {
  fetchChangeTypeMap: FetchActionWithOutParams<UserChangeTypeMap>;
}

type Store = StoreState & StoreActions;
const store = (set: any, get: any) => ({
  changeTypeMap: {},

  fetchChangeTypeMap: async (
    action: FetchApiWithoutParams<UserChangeTypeMap>,
  ) => {
    set({ loading: true });
    const result = await action();
    if (result.data) {
      set({ changeTypeMap: result.data });
    }

    return result;
  },
});

export const useUserChangeStore = create<Store>()(store);
